const data = [
  {
    id: 1,
    name: 'dan',
    image: 'http://unsplash.it/200?random&gravity=center',
    position: 'programmer',
    phone: '01000000000000',
    email: 'email@email.email',
    website: 'website.com',
  },
  {
    id: 2,
    name: 'jeo',
    image: 'http://unsplash.it/200?random&gravity=center',
    position: 'programmer',
    phone: '01000000000000',
    email: 'email@email.email',
    website: 'website.com',
  },
  {
    id: 3,
    name: 'ben',
    image: 'http://unsplash.it/200?random&gravity=center',
    position: 'programmer',
    phone: '01000000000000',
    email: 'email@email.email',
    website: 'website.com',
  },
  {
    id: 4,
    name: 'jeo',
    image: 'http://unsplash.it/200?random&gravity=center',
    position: 'programmer',
    phone: '01000000000000',
    email: 'email@email.email',
  },
  {
    id: 5,
    name: 'ben',
    image: 'http://unsplash.it/200?random&gravity=center',
    position: 'programmer',
    phone: '01000000000000',
    email: 'email@email.email',
    website: 'website.com',
  },
  {
    id: 6,
    name: 'jeo',
    image: 'http://unsplash.it/200?random&gravity=center',
    position: 'programmer',
    phone: '01000000000000',
    email: 'email@email.email',
    website: 'website.com',
  },
  {
    id: 7,
    name: 'ben',
    image: 'http://unsplash.it/200?random&gravity=center',
    position: 'programmer',
    phone: '01000000000000',
    email: 'email@email.email',
  },
  {
    id: 8,
    name: 'jeo',
    image: 'http://unsplash.it/200?random&gravity=center',
    position: 'programmer',
    phone: '01000000000000',
    email: 'email@email.email',
    website: 'website.com',
  },
  {
    id: 9,
    name: 'ben',
    image: 'http://unsplash.it/200?random&gravity=center',
    position: 'programmer',
    phone: '01000000000000',
    email: 'email@email.email',
    website: 'website.com',
  },
  {
    id: 10,
    name: 'jeo',
    image: 'http://unsplash.it/200?random&gravity=center',
    position: 'programmer',
    phone: '01000000000000',
    email: 'email@email.email',
  },
  {
    id: 11,
    name: 'ben',
    image: 'http://unsplash.it/200?random&gravity=center',
    position: 'programmer',
    phone: '01000000000000',
    email: 'email@email.email',
    website: 'website.com',
  },
];

export default data;
